export const PageListButtonsType = {
  OpenPage: 'OPEN_PAGE',
  EditStatus: 'EDIT_STATUS'
};
